var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPointerBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.002 35.14a1.442 1.442 0 0 0-1.25 2.165l5.669 9.817a1.443 1.443 0 0 0 2.499 0l5.668-9.817a1.443 1.443 0 0 0-1.25-2.164H11.002z",
    id: "514vxexi9a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.806 20.082a2.726 2.726 0 0 1-2.723 2.723h-6.825a2.726 2.726 0 0 1-2.724-2.723v-6.825a2.726 2.726 0 0 1 2.724-2.723h6.825a2.726 2.726 0 0 1 2.723 2.723v6.825zM9.624 0C4.309 0 0 4.308 0 9.623v14.093c0 5.315 4.309 9.623 9.624 9.623h14.093c5.314 0 9.623-4.308 9.623-9.623V9.623C33.34 4.308 29.031 0 23.717 0H9.624z",
    id: "jicifhz7xb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#EE4320",
    xlinkHref: "#514vxexi9a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#514vxexi9a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#EE4320",
    xlinkHref: "#jicifhz7xb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#jicifhz7xb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPointerBlack);
export default __webpack_public_path__ + "static/media/location_pointer_black.0ba689c17218f2acb24d5004cf316d3b.svg";
export { ForwardRef as ReactComponent };